export const MANAGE_CREDIT_LIMIT = 22
export const CREATE_PBX = 23
export const UPLOAD_PROVISION_FILE = 24
export const DOWNLOAD_PBX_DATA = 25
export const DISABLE_PBX = 26
export const VIEW_SIPCENTRIC_CUSTOMER_LIST = 77
export const EXPORT_SIPCENTRIC_CUSTOMER_LIST = 78
